import { render } from "./DocBookWidget.vue?vue&type=template&id=f4f84648&scoped=true"
const script = {}

import "./DocBookWidget.vue?vue&type=style&index=0&id=f4f84648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f84648"]])

export default __exports__